// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isCdiJobsResults = objectOf({
  job_run_id: string,
  integration_id: string,
  updated_at: string,
  job_status: string,
  rows_read: number,
  rows_ingested: number,
  rows_rejected_in_read: number,
  rows_rejected_in_ingest: number,
  s3_file_path: string,
  finish_sync_timestamp: string,
});
